const clearError = (
    errorElement
) => {
    if (!errorElement) {
        return;
    }

    errorElement.textContent = '';

    errorElement.classList.add(
        'hidden'
    );
};

const showError = (
    errorElement,
    message
) => {
    if (!errorElement) {
        return;
    }

    errorElement.textContent =
        message;

    errorElement.classList.remove(
        'hidden'
    );
};

export const clearReactionError = (
    reactionError
) => {
    clearError(
        reactionError
    );
};

export const showReactionError = (
    reactionError,
    message
) => {
    showError(
        reactionError,
        message
    );
};

export const clearReactionsError = (
    reactionsError
) => {
    clearError(
        reactionsError
    );
};

export const showReactionsError = (
    reactionsError,
    message
) => {
    showError(
        reactionsError,
        message
    );
};

export const clearCommentsError = (
    commentsError
) => {
    clearError(
        commentsError
    );
};

export const showCommentsError = (
    commentsError,
    message
) => {
    showError(
        commentsError,
        message
    );
};

export const clearCommentFormError = (
    commentFormError
) => {
    clearError(
        commentFormError
    );
};

export const showCommentFormError = (
    commentFormError,
    message
) => {
    showError(
        commentFormError,
        message
    );
};

export const clearCommentDeleteError = (
    commentDeleteError
) => {
    clearError(
        commentDeleteError
    );
};

export const showCommentDeleteError = (
    commentDeleteError,
    message
) => {
    showError(
        commentDeleteError,
        message
    );
};